import { apiFetch } from './api';

/**
 * Generate invoice for a licence
 */
export function generateInvoice(licenceId) {
  return apiFetch(`/api/admin/invoices/licences/${licenceId}/generate`, {
    method: 'POST'
  });
}

/**
 * Get invoice details
 */
export function getInvoice(invoiceId) {
  return apiFetch(`/api/admin/invoices/${invoiceId}`);
}

/**
 * List invoices
 */
export function listInvoices({ page = 1, limit = 20, status, customerId, licenceId } = {}) {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('limit', String(limit));
  if (status) params.set('status', status);
  if (customerId) params.set('customerId', customerId);
  if (licenceId) params.set('licenceId', licenceId);
  
  return apiFetch(`/api/admin/invoices?${params.toString()}`);
}

/**
 * Send invoice via email
 */
export function sendInvoice(invoiceId) {
  return apiFetch(`/api/admin/invoices/${invoiceId}/send`, {
    method: 'POST'
  });
}

/**
 * Get invoice PDF (returns blob)
 */
export async function getInvoicePDF(invoiceId) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';
  const token = localStorage.getItem('auth_token') || '';
  
  const res = await fetch(`${API_BASE_URL}/api/admin/invoices/${invoiceId}/pdf`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  
  if (!res.ok) {
    throw new Error('Failed to get invoice PDF');
  }
  
  return res.blob();
}

/**
 * Sync invoice to Xero
 */
export function syncInvoice(invoiceId) {
  return apiFetch(`/api/admin/invoices/${invoiceId}/sync`, {
    method: 'POST'
  });
}

/**
 * Void invoice (and in Xero if synced). Frees the licence so a new invoice can be generated.
 */
export function voidInvoice(invoiceId) {
  return apiFetch(`/api/admin/invoices/${invoiceId}/void`, {
    method: 'PUT'
  });
}

/**
 * Refund a paid invoice (full amount only). Stripe + Xero (credit note and refund payment recorded).
 * @param {string} invoiceId
 * @param {{ reason?: string }} [options] - optional reason
 */
export function refundInvoice(invoiceId, options = {}) {
  return apiFetch(`/api/admin/invoices/${invoiceId}/refund`, {
    method: 'POST',
    body: options?.reason ? { reason: options.reason } : {}
  });
}


